import React, { useState } from "react";
import PropTypes from "prop-types";
import Text, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_HEADING_LEVEL,
  TEXT_KIND,
  TEXT_SEGMENT,
  TEXT_SIZE,
} from "@/bit/components/next13.components.text";
import Glyph from "@/bit/components/next13.components.icon-glyph";
import CustomLink from "@/bit/components/next13.components.custom-link";

export const COMPONENT_NAME = "Faqs";
export { TEXT_COLOR, TEXT_SEGMENT };


const Faqs = ({
  openAllQuestions,
  listadoFAQS,
  iconColor,
  titleColorClosed,
  titleColorOpen,
  borderBottomOnly,
  segment,
  className,
}) => {
  const [openIndices, setOpenIndices] = useState(
    openAllQuestions ? listadoFAQS.map((_, index) => index) : []
  );

  const toggleQuestion = (index) => {
    setOpenIndices((prevOpenIndices) =>
      prevOpenIndices.includes(index)
        ? prevOpenIndices.filter((i) => i !== index)
        : [...prevOpenIndices, index]
    );
  };

  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentContent: "",
    componentProduct: "",
    componentVariation: "none",
    eventType: "click",
  };

  return (
    <section className={`faqs ${className}`}>
      {listadoFAQS.map((faq, index) => (
        <div
          key={index}
          className={`faq-item ${
            borderBottomOnly ? "faq-item--with-bottom-border" : "faq-item--with-borders"
          }`}
        >
          <CustomLink
            title={faq.title}
            taggingInfo={{
              ...taggingInfo,
              componentProduct: `faqItem-${index}`,
              componentContent: openIndices.includes(index) ? "faq-plegar" : "faq-desplegar",
              componentVariation: "none",
              eventType: "click",
            }}
            className={`faq-title ${openIndices.includes(index) ? "open" : ""}`}
            onClick={() => toggleQuestion(index)}
          >
            <Text
              text={faq.title}
              kind={TEXT_KIND.HEADING}
              level={TEXT_HEADING_LEVEL.H3}
              align={TEXT_ALIGN.LEFT}
              color={openIndices.includes(index) ? titleColorOpen : titleColorClosed}
              size={TEXT_SIZE.TITLE6}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
              segment={segment}
              className="text-content"
            />
            <span>
              <Glyph 
                id="cheuron-up-m" 
                color={iconColor}
                width={16}
                layoutSize={{
                  h: 16,
                  w: 16,
                }}
              />
            </span>
          </CustomLink>
          <div className={`faq-description ${openIndices.includes(index) ? "open" : ""}`}>
            <Text
              color={TEXT_COLOR.GREY6}
              size={TEXT_SIZE.CAPTION1}
              segment={segment}
              className="text-content"
              text={faq.description}
            />
          </div>
        </div>
      ))}
    </section>
  );
};

Faqs.propTypes = {
  /**
   * Booleano que nos permite abrir todas las preguntas por defecto
   */
  openAllQuestions: PropTypes.bool,
  /**
   * Listado de preguntas frecuentes/faqs
   */
  listadoFAQS: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  /**
   * Color del icono
   */
  iconColor: PropTypes.string,
  /**
   * Color del texto abierto
   */
  titleColorOpen: PropTypes.string,
  /**
   * Color del texto cerrado
   */
  titleColorClosed: PropTypes.string,
  /**
   * Faqs con border o no
   */
  borderBottomOnly: PropTypes.bool,
  /**
   *  Necesita para especificar el segmento
   */
  segment: PropTypes.string,
  className: PropTypes.string,
};

Faqs.defaultProps = {
  openAllQuestions: false,
  iconColor: TEXT_COLOR.BLUE,
  titleColorClosed: TEXT_COLOR.GREY5,
  titleColorOpen: TEXT_COLOR.GREY6,
  borderBottomOnly: true,
  segment: TEXT_SEGMENT.GP,
  className: "",
};

export default Faqs;
